import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import DropDownOA from '../../../../common/dropDownOA'
import Lineinput from '../../../../common/lineinput'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import AddandRemoveBtn from './AddandRemoveBtn'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import ConsignmentHistoryTable from './ConsignmentHistoryTable';
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal';
import { useTranslation } from '../../../../../i18n/I18nProvider'
//import { getPartyWeightChrg } from '../../../../../store/generalSetting/GSAction';

const UpdateChrgWeightModal = ({ data, updateModal, updateAlertError, getPartyWeightChrg, updatePartyWeightChrg }) => {
  const { translations } = useTranslation()
  const cs = translations?.common || {}
  const { headText, isUpdate, ConsignmentTypeList, loginData, partyList } = data
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [weightChrg, setWeightChrg] = useState([])
  const [showData, setShowData] = useState(false)
  const [selConsignmentType, setSelConsignmentType] = useState()
  const [selParty, setSelParty] = useState()
  const [showHistoryTable, setShowHistoryTable] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [ratesSaved, setRatesSaved] = useState(false)
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    focusElemnt('select_party_weightChrg')
  }, [])
  const tableHeader = [
    { headerName: tr('rangeFromUnit', 'Range From Unit'), headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: tr('rangeToUnit', 'Range To Unit'), headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: tr('minWeightChrgInKg', 'Min Weight Chrg.(in KG)'), headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: tr('gsAction', 'Action'), headerSx: { minWidth: '25%', textAlign: 'left' } },
  ]
  const handleChangeWeightChrg = (event, field, index) => {
    let oldData = [...weightChrg.map((val, i) => (i === index ? { ...val, [field]: event.target.value } : val))]
    if (field === 'FromNOP') {
      oldData[index - 1].ToNOP = event.target.value !== '' ? event.target.value - 1 : event.target.value
    }
    setWeightChrg(oldData)
  }
  const handleWeightChrg = (event, field, index) => {
    if (field === 'ToNOP' && isUpdate && parseInt(event.target.value) > 99999) {
      updateAlertError({ show: true, msg: tr('gsToNopMax', 'To NOP value should not exceed 99999'), nextId: `ToNOP-${index}` })
      resetWeightChrg(event, field, index)
    } else if (
      field === 'ToNOP' &&
      isUpdate &&
      event.target.value !== '' &&
      (event.target.value !== '' ? parseInt(event.target.value) <= weightChrg[index].FromNOP : true)
    ) {
      updateAlertError({ show: true, msg: tr('gsToNopGtFromNop', 'To NOP value should greater than FromNOP'), nextId: `ToNOP-${index}` })
      resetWeightChrg(event, field, index)
    } else if (field === 'FromNOP' && event.target.value !== '') {
      if (parseInt(event.target.value) <= weightChrg[index - 1].FromNOP) {
        updateAlertError({ show: true, msg: tr('gsGtPrev', 'Value must be greater than previous value'), nextId: `FromNOP-${index}` })
        resetWeightChrg(event, field, index)
      } else if (
        weightChrg.length - 1 > index
          ? weightChrg[index + 1]?.FromNOP !== ''
            ? parseInt(event.target.value) >= weightChrg[index + 1]?.FromNOP
            : false
          : false
      ) {
        updateAlertError({ show: true, msg: tr('gsLtNext', 'Value must be less than next value'), nextId: `FromNOP-${index}` })
        resetWeightChrg(event, field, index)
      } else if (parseInt(event.target.value) >= 99999) {
        updateAlertError({ show: true, msg: tr('gsFromNopMax', 'FromNOP should not exceed 99999'), nextId: `FromNOP-${index}` })
        resetWeightChrg(event, field, index)
      } else if (
        isUpdate &&
        (index === 3 && weightChrg[index].ToNOP !== '' ? parseInt(event.target.value) > weightChrg[index].ToNOP : false)
      ) {
        updateAlertError({ show: true, msg: tr('gsLtToNop', 'Value must be less than TONOP value'), nextId: `FromNOP-${index}` })
        resetWeightChrg(event, field, index)
      }
    }
  }
  const resetWeightChrg = (event, field, index) => {
    let oldData = [...weightChrg.map((val, i) => (i === index ? { ...val, [field]: '' } : val))]
    if (field === 'FromNOP') {
      oldData[index - 1].ToNOP = ''
    }
    setWeightChrg(oldData)
  }
  const handleAddWeightChrg = (index) => {
    let newData = { FromNOP: '', ToNOP: weightChrg[index].ToNOP, weightChrg: 0 }
    let newArr = [...weightChrg.map((val, i) => (i === index ? { ...val, ToNOP: '' } : val))]
    newArr.splice(index + 1, 0, newData)
    setWeightChrg(newArr)
  }
  const handleRemoveWeightChrg = (index) => {
    let oldToNOP = weightChrg[index].ToNOP
    let newData = weightChrg.filter((val, i) => i !== index)
    setWeightChrg([...newData.map((val, i) => (i === index - 1 ? { ...val, ToNOP: oldToNOP } : val))])
  }
  const hasEmptyValue = (array, properties) => {
    return array.some((obj) => {
      return properties.some((prop) => {
        const value = obj[prop]
        return value === '' || value == null
      })
    })
  }
  const resetAllChrg = () => {
    setShowData(false)
    setWeightChrg([])
  }
  const getWeightChrgValue = () => {
    resetAllChrg()
    if (selParty == undefined) {
      updateAlertError({ show: true, msg: tr('selectPartyErr', 'Select Party..!'), nextId: 'Select_Party' })
      return;
    }
    if (selConsignmentType == undefined) {
      updateAlertError({ show: true, msg: tr('selectConsignmentTypeErr', 'Select Consignment Type..!'), nextId: 'Select_Consignment_Type' })
      return;
    }
        const body = {
      PartyID: selParty?.PartyID,
      CompanyID: loginData?.intCompanyID,
      ConsignmentTypeID: selConsignmentType?.ConsignmentSubTypeID,
    }
    getPartyWeightChrg(body)
      .then((res) => {
        if (res.status === 'Success') {
                    if (res.Data.Table.length > 0) {
            setShowData(true)
            setWeightChrg(res.Data.Table.sort((a, b) => a.FromNOP - b.FromNOP))
            setRatesSaved(true)
          } else {
            setShowData(true)
            setWeightChrg([{ FromNOP: 1, ToNOP: 99999, MinimumWeightCharge: 0 }])
            setRatesSaved(false)
          }
        } else {
          updateAlertError({ show: true, msg: res?.Message, nextId: 'Consignment_Type' })
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
  }
  const handleSaveAndUpdateChrg = () => {
    if (selParty == undefined) {
      updateAlertError({ show: true, msg: tr('selectPartyErr', 'Select Party..!'), nextId: 'Select_Party' })
      return;
    }
    if (selConsignmentType == undefined) {
      updateAlertError({ show: true, msg: tr('selectConsignmentErr', 'Select Consignment..!'), nextId: 'Select_Consignment_Type' })
      return;
    }
    const body = {
      CompanyID: loginData?.intCompanyID,
      PartyID: selParty?.PartyID,
      ConsignmentID: selConsignmentType?.ConsignmentSubTypeID,
      TypeQtyChg: weightChrg.map((val) => `${val.FromNOP}-${val.ToNOP}-${val.MinimumWeightCharge}`).join(','),
      UserID: loginData?.intUserID
    }
    updatePartyWeightChrg(body)
      .then((res) => {
        if (res.status === 'Success') {
          resetAllChrg()
          setIsSuccess(true)
          setRatesSaved(true)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          setRatesSaved(false)
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
  }
  return (
    <>
      <Modal
        headTxt={headText}
        width={'70%'}
        updateModal={updateModal}
        closeId={'closeButton'}
        modalClass={'booking-popup'}
        modalStyle={modalStyle}
      >
        <Box sx={{ display: 'flex', padding: '15px' }} className="itemButtons">

          <Item sx={{ ...sx.itemsx, paddingRight: '12px' }}>
            <DropDownOA
              id={'select_party_weightChrg'}
              label={tr('selectParty', 'Select Party')}
              data={partyList}
              defaultvalue={selParty?.Party}
              idKey={`PartyID`}
              dataKey={`Party`} onSelect={(val) => {
                setSelParty(val);setShowHistoryTable(false)
              }}
              width="280px"
              prevId={``}
              nextId={'Consignment_Type_weightChrg'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }}>
            <DropDownOA
              id={'Consignment_Type_weightChrg'}
              label={tr('selectConsignmentType', 'Select Consignment Type')}
              // defaultvalue={selConsignmentType?.SubType || selConsignmentType}
              data={ConsignmentTypeList || []}
              idKey={`ConsignmentSubTypeID`}
              dataKey={`SubType`}
              onSelect={(val) => {
                resetAllChrg()
                setSelConsignmentType(val)
                setShowHistoryTable(false)
              }}
              width="280px"
              nextId={'loadBtn'}
              prevId={'select_party_weightChrg'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id={'loadBtn'}
              sx={{ paddingY: '6px !important' }}
              onClick={() => {
                getWeightChrgValue()
              }}
              className="receiveitembtn"
              onKeyDown={(e) => navigation3(e, 'saveRatesBtn', 'Consignment_Type_weightChrg', () => { })}
            >
              {tr('gsLoad', 'Load')}
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} >
            <Button
              variant="outlined"
              id={'saveRatesBtn'}
              sx={{ paddingY: '6px !important' }}
              disabled={!showData}
              onClick={handleSaveAndUpdateChrg}
              className="receiveitembtn"
              onKeyDown={(e) => navigation3(e, 'historyBtn', 'loadBtn', () => { })}
            >
              {tr('gsSave', 'SAVE')}
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id={'historyBtn'}
              sx={{ paddingY: '6px !important' }}
              onClick={() => {
                setShowHistoryTable(!showHistoryTable)
              }}
              disabled={!showData||!ratesSaved}
              className="receiveitembtn"
              onKeyDown={(e) => navigation3(e, 'select_party_weightChrg', 'saveRatesBtn', () => { })}
            >
              {showHistoryTable ? tr('hideHistory', 'HIDE HISTORY') : tr('showHistory', 'SHOW HISTORY')}
            </Button>
          </Item>
        </Box>
        <Box sx={{ display: 'flex', paddingX: '15px', marginBottom: '5px', width: '65%' }}>
          <TableContainer component={Paper} className="scroll" sx={{ marginBottom: '5px' }}>
            <Table
              stickyHeader
              size="small"
              aria-label="a dense table"
              sx={{
                '& .MuiTableCell-root': {
                  padding: '6px 4px !important',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  {tableHeader.map((row, index) => {
                    return (
                      <TableCell
                        sx={{
                          ...row.headerSx,
                          backgroundColor: '#DAEDFE',
                          minHeight: '36px',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#444',
                        }}
                      >
                        {row.headerName}
                      </TableCell>
                    )
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {showData ? (
                  weightChrg.map((row, index) => {
                    return (
                      <TableRow>
                        <TableCell>
                          <div className={'input--wrapper btmSpaceNotRequired'}>
                            <Lineinput
                              label={''}
                              id={`FromNOP-${index}`}
                              disabled={index === 0}
                              textAlign={'end'}
                              value={row.FromNOP}
                              onChange={(e) => handleChangeWeightChrg(e, 'FromNOP', index)}
                              onBlur={(e) => handleWeightChrg(e, 'FromNOP', index)}
                              onKeyDown={(e) =>
                                navigation3(
                                  e,
                                  isUpdate && index === 3 ? `ToNOP-${index}` : `chrg-${index}`,
                                  weightChrg.length >= 4 ? `chrg-${index - 1}` : `addBtn-${index}`,
                                  () => { }
                                )
                              }
                            />
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={'input--wrapper btmSpaceNotRequired'}>
                            <Lineinput
                              label={''}
                              id={`ToNOP-${index}`}
                              disabled={isUpdate && index === 3 ? false : true}
                              value={row.ToNOP}
                              textAlign={'end'}
                              onChange={(e) => handleChangeWeightChrg(e, 'ToNOP', index)}
                              onBlur={(e) => handleWeightChrg(e, 'ToNOP', index)}
                              onKeyDown={(e) => navigation3(e, `chrg-${index}`, `FromNOP-${index}`, () => { })}
                            />
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={'input--wrapper btmSpaceNotRequired'}>
                            <Lineinput
                              label={''}
                              id={`chrg-${index}`}
                              value={row.MinimumWeightCharge}
                              textAlign={'end'}
                              onChange={(e) => handleChangeWeightChrg(e, 'MinimumWeightCharge', index)}
                              onBlur={(e) => handleWeightChrg(e, 'MinimumWeightCharge', index)}
                              onKeyDown={(e) =>
                                navigation3(
                                  e,
                                  weightChrg.length >= 4
                                    ? weightChrg.length - 1 !== index
                                      ? `FromNOP-${index + 1}`
                                      : `removebtn-${index}`
                                    : `addBtn-${index}`,
                                  isUpdate && index === 3 ? `ToNOP-${index}` : index === 0 ? 'goBtn' : `FromNOP-${index}`,
                                  () => { }
                                )
                              }
                            />
                          </div>
                        </TableCell>
                        <TableCell>
                          <AddandRemoveBtn
                            addRow={handleAddWeightChrg}
                            removeRow={handleRemoveWeightChrg}
                            index={index}
                            data={weightChrg}
                            onKeyDownAdd={(e) =>
                              navigation3(
                                e,
                                weightChrg.length - 1 === index
                                  ? index === 0
                                    ? 'activeDeliveryCharge'
                                    : `removebtn-${index}`
                                  : `FromNOP-${index + 1}`,
                                `chrg-${index}`,
                                () => { }
                              )
                            }
                            onKeyDownRemove={(e) =>
                              navigation3(e, 'activeDeliveryCharge', weightChrg.length >= 4 ? `chrg-${index}` : `addBtn-${index}`, () => { })
                            }
                          />
                        </TableCell>
                      </TableRow>
                    )
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}>
                      {tr('gsNoResult', 'No Result Found')}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {showHistoryTable ?
          <Box sx={{ padding: '16px' }}>
            <Box style={{ color: '#444444', fontSize: '14px', fontWeight: '500', lineHeight: '16.41px', marginBottom: '12px' }}>{tr('consignmentHistory', 'CONSIGNMENT HISTORY')}</Box>
            <ConsignmentHistoryTable
              updateModal={updateModal}
              // reportData={reportData}
              // showModal={showModal}
              // modalType={modalType}
              cnsgnmntTypes={[]}
              loginData={loginData}
              updateAlertError={updateAlertError}
              data={weightChrg}
            //  getDemurrageChrgList={getDemurrageChrgList}
            />
          </Box> : null}

      </Modal>
      <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); updateModal(); focusElemnt('gicGSTNo') }} open={isSuccess} title={cs.chargeWeightSavedSuccessfullyNl || 'Charge Weight\n Saved Successfully!'} modalStyle={modalStyle} />
    </>
  )
}

export default UpdateChrgWeightModal
